module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/150.191dbd93.png";